import { createTermTagManager } from '../../utils/createTermTagManager';

export const domrfTagManager = createTermTagManager({
  jsonQueryKey: 'domrf',
  label: 'Аренда от ДОМ.РФ',
  id: 'domrf',
});
